export default function HowItWorksSection() {
  const steps = [
    {
      step: "01",
      icon: "ri-search-eye-line",
      title: "Browse Categories",
      description:
        "Start by exploring the 14 organized fashion categories in the Vigorbuy Spreadsheet. Each category is clearly labeled and easy to navigate, giving you a bird's-eye view of available product types.",
    },
    {
      step: "02",
      icon: "ri-scales-line",
      title: "Compare Options",
      description:
        "Use the structured layout to compare different items side by side. The spreadsheet format makes it effortless to evaluate features, styles, and references across multiple products simultaneously.",
    },
    {
      step: "03",
      icon: "ri-book-open-line",
      title: "Read Guides",
      description:
        "Access detailed guides and tutorials that explain how to get the most out of the Vigorbuy Spreadsheet. From beginner tips to advanced navigation strategies, every resource is crafted for clarity.",
    },
    {
      step: "04",
      icon: "ri-compass-3-line",
      title: "Explore Resources",
      description:
        "Dive deeper into curated resources that complement your product discovery journey. Find linked references, safety information, and category-specific insights all in one organized hub.",
    },
    {
      step: "05",
      icon: "ri-check-double-line",
      title: "Make Informed Decisions",
      description:
        "With all the information at your fingertips, confidently choose the products that best match your needs. The Vigorbuy Spreadsheet empowers you to shop smarter, not harder.",
    },
  ];

  return (
    <section id="how-it-works" className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="max-w-6xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-12 md:mb-16">
            <span className="inline-block text-xs font-medium text-accent-600 bg-accent-100 px-3 py-1 rounded-full mb-4 tracking-wide">
              GETTING STARTED
            </span>
            <h2 className="text-2xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight mb-4">
              How It{" "}
              <span className="text-accent-600">Works</span>
            </h2>
            <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto">
              Five simple steps to master the Vigorbuy Spreadsheet and transform
              your product discovery experience.
            </p>
          </div>

          {/* Steps */}
          <div className="grid grid-cols-1 md:grid-cols-5 gap-4 md:gap-3">
            {steps.map((s, idx) => (
              <div
                key={s.step}
                className="relative group"
              >
                {/* Step Card */}
                <div className="bg-background-50 border border-background-200/70 rounded-2xl p-6 md:p-5 h-full hover:border-accent-300 hover:bg-accent-50/20 transition-all duration-300">
                  <div className="flex items-center gap-3 mb-4">
                    <span className="text-3xl font-heading font-bold text-accent-200">
                      {s.step}
                    </span>
                  </div>
                  <div className="w-10 h-10 rounded-xl bg-accent-100 flex items-center justify-center mb-4">
                    <i className={`${s.icon} text-lg text-accent-600`}></i>
                  </div>
                  <h3 className="text-base font-heading font-semibold text-foreground-900 mb-2">
                    {s.title}
                  </h3>
                  <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                    {s.description}
                  </p>
                </div>

                {/* Connector Arrow (desktop only) */}
                {idx < steps.length - 1 && (
                  <div className="hidden md:block absolute top-1/2 -right-2 z-10">
                    <i className="ri-arrow-right-s-line text-foreground-300 text-lg"></i>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}